export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "container_scheduled_service": {
            "scheduled_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha"])},
            "started_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de inicio"])},
            "finished_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de fin"])},
            "observations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Observaciones"])},
            "status_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Estado"])},
            "agro_exporter_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cliente"])},
            "service_provider_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Proveedor de servicios"])},
            "container_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedor"])},
            "service_templates": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Servicios"])},
            "container_schedule_technicians": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Responsables"])}
          }
        }
      },
      "en": {
        "model": {
          "container_scheduled_service": {
            "scheduled_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Scheduled at"])},
            "started_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Started at"])},
            "finished_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finished at"])},
            "observations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Observations"])},
            "status_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
            "agro_exporter_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Agro exporter"])},
            "service_provider_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Service provider"])},
            "container_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container"])},
            "service_templates": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Services"])}
          }
        }
      }
    }
  })
}